import { trialDays } from '@listening/frontend/pricing';
import * as m from '@/paraglide/messages';

// Free-plan countries get a free tier, not a trial, so only everyone else is
// promised days (see test/unit/cta-label.spec.ts).
export function getDefaultCtaLabel(isFreePlanAvailable: boolean): string {
  if (isFreePlanAvailable) return m.common_try_for_free();
  return m.common_try_free_for_days({ trialDays: String(trialDays) });
}
